import { NicheFields, NicheFieldsNames } from "components/popups/NicheForm/NicheForm";

export const EDIT_NICHE_FIELDS: { [key in NicheFieldsNames]: NicheFields } = {
  [NicheFieldsNames.name]: {
    id: "name",
    label: "Name - Cannot be changed",
    placeholder: "My Niche Name!",
    validation: {
      required: "Give your niche a unique name"
    },
    type: "text",
    disabled: true,
    defaultValue: "",
  },
  [NicheFieldsNames.description]: {
    id: "description",
    label: "Description",
    placeholder: "This is description of my niche",
    validation: {
      required: "Let other users know what this niche is about",
      minLength: { value: 30, message: "Longer descriptions help other users (min 30 characters)" }
    },
    rows: 3,
    defaultValue: "",
  }
};

type NicheValues = {
  name: string | null;
  description: string | null;
}

export const getFieldsWithValues = (
  fields: { [key in NicheFieldsNames]: NicheFields },
  values: NicheValues
) => {
  const copyFields = { ...fields };

  Object.keys(values).forEach((key: string) => {
    copyFields[key as keyof NicheValues].defaultValue = values[key as keyof NicheValues] || "";
  });

  return copyFields;
};
